import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { TitleScene } from './scenes/TitleScene';
import { GlenLoadScene } from './ui/glenLoad';
import { installTextureBind } from './ui/bindTexture';
import { installTextureStandIn } from './ui/standIn';
import { installPortrait } from './ui/portrait';
import { detectRasterFormat, setRasterFormat } from './ui/raster';
import { BleedPlugin, canvasFor } from './ui/bleed';
import { stage } from './ui/stage';

const format = await detectRasterFormat();
setRasterFormat(format);
installTextureBind(Phaser.GameObjects);
installTextureStandIn();

const box = canvasFor(window.innerWidth, window.innerHeight, stage.w, stage.h);
const forceCanvas = new URLSearchParams(window.location.search).get('renderer') === 'canvas';

const game = new Phaser.Game({
  type: forceCanvas ? Phaser.CANVAS : Phaser.AUTO,
  parent: 'game',
  width: box.w,
  height: box.h,
  backgroundColor: '#e7b07a',
  banner: false,
  plugins: {
    scene: [{ key: 'bleed', plugin: BleedPlugin, mapping: 'bleed' }],
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: box.w,
    height: box.h,
  },
  render: {
    antialias: true,
    roundPixels: true,
    preserveDrawingBuffer: true,
  },
  scene: [BootScene, TitleScene, GlenLoadScene],
});

installPortrait(game);
Object.assign(globalThis, { __critter: game });
